import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { palette } from '../../../theme/colors';

export const Circle = forwardRef<google.maps.Circle, google.maps.CircleOptions>((options, ref) => {
  const circleRef = useRef(
    new google.maps.Circle({
      strokeColor: 'transparent',
      strokeWeight: 0,
      fillColor: palette.applGreen,
      fillOpacity: 0.4,
    })
  );
  useImperativeHandle(ref, () => circleRef.current);

  useEffect(() => {
    circleRef.current.setOptions(options);
  }, [circleRef, options]);

  useEffect(() => {
    const circle = circleRef.current;
    return () => circle.setMap(null);
  }, [circleRef]);

  return null;
});
